export default "__VITE_PUBLIC_ASSET__40b57ae4__"